function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 90.7883,
  y: 36.9099,
  width: 91.4046,
  height: 81.1321
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M204.9523,60.2765,165.2672,18.3949a13.2717,13.2717,0,0,0-9.528-4.1748H60.5847c-7.4427,0-13.4831,6.3762-13.4831,14.2325V94.871a4.6261,4.6261,0,0,0,4.4944,4.7443H62.8319a2.313,2.313,0,0,1,2.2472,2.372v23.7209a2.3131,2.3131,0,0,1-2.2472,2.3721H51.596a4.626,4.626,0,0,0-4.4944,4.7441V227.708c0,7.8563,6.04,14.2325,13.4831,14.2325H195.4153c7.4427,0,13.4831-6.3762,13.4831-14.2325V70.3437A14.754,14.754,0,0,0,204.9523,60.2765ZM130.2472,47.4388a6.7514,6.7514,0,1,1,13.483,0V94.8806a6.7514,6.7514,0,1,1-13.483,0Zm-35.9548,0a6.7514,6.7514,0,1,1,13.483,0V94.8806a6.7514,6.7514,0,1,1-13.483,0Zm85.3927,56.9206a6.7514,6.7514,0,1,1-13.4831,0V66.406a6.7514,6.7514,0,1,1,13.4831,0Z",
  fill: "#fff"
});

var SvgWebappIconSdCardInsertedDarkTheme = function SvgWebappIconSdCardInsertedDarkTheme(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWebappIconSdCardInsertedDarkTheme, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/webapp-icon-sd-card-inserted-dark-theme.38e7922b.svg";
export { ForwardRef as ReactComponent };